import { Outlet } from "react-router-dom";

/**
 * @abstract base view warpper for everything
 */
export default function GlobalLayoutWrapper() {
  return (
    <div 
      className={`flex flex-1 w-full text-white`}
    >
      <Outlet />
    </div>
  );
}